import { Fragment, useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import TabelaV2 from "../TabelaV2.js";
import RenderBodyColunas from "./RenderBodyColunas.js";
import RenderBodyNomeTabela from "./RenderBodyNomeTabela.js";

const Entregas = [
    {
        nomeColuna: "Pedido",
        field: "pedidoId",
    },
    {
        nomeColuna: "Classificação",
        field: "classificacao",
    },
    {
        nomeColuna: "Frete Motorista",
        field: "freteMotorista",
    },
    {
        nomeColuna: "Frete Fiscal",
        field: "freteFiscal",
    },
    {
        nomeColuna: "ICMS",
        field: "icms",
    },
    {
        nomeColuna: "Pedágio",
        field: "pedagio",
    },
    {
        nomeColuna: "CTE",
        field: "cte",
    },
];

interface TableBodyOrdenadoProps {
    dadosOrdenados: Array<any>;
    classeSelecionado: string;
    striped?: boolean;
    selecionado?: any;
    nomeTable?: string;
    breakTd: any;
    isEmbarque: boolean;
    colunas: Array<any>;
    linhaSelecionada: Array<any>;
    listaTipos: Record<string, any>;
    listaTipos2: Record<string, any>;
    setOpenMotivo: (value: boolean) => void;
    setOpen: (value: boolean) => void;
    setDadosRastrearRedux: (value: any) => void;
    setOpenRegras: (value: boolean) => void;
    setValues: (value: any) => void;
    setIsEmbarque: (value: boolean) => void;
    setIsEntrega: (value: boolean) => void;
    dadosEntrega: Record<string, any>;
    showDropDowEmbarques: (row: any) => void;
    navigate: (path: string, options?: any) => void;
    handleHover: (index: number | null) => void;
    setLista: (lista: any, id: any) => void;
    setTabelaRow: (row: any) => void;
    setIdEmbarque: (id: any) => void;
    setDadosEmb: (dados: any) => void;
    setTelaCadastro: (value: boolean) => void;
    setEditando: (value: boolean) => void;
    setTabelaRedux: (value: any) => void;
    setOpenHistoricoEdicao: (value: boolean) => void;
    setTelaCheck: () => void;
    setSelecionado: (value: any) => void;
    configEntrega: any;
}

function TableBodyOrdenado({
    dadosOrdenados,
    classeSelecionado,
    selecionado,
    striped,
    nomeTable,
    breakTd,
    setOpenMotivo,
    colunas,
    linhaSelecionada,
    listaTipos,
    listaTipos2,
    setOpen,
    setIsEmbarque,
    setDadosRastrearRedux,
    setOpenRegras,
    setIsEntrega,
    setValues,
    dadosEntrega,
    isEmbarque,
    showDropDowEmbarques,
    handleHover,
    setLista,
    setTabelaRow,
    setIdEmbarque,
    setDadosEmb,
    setTelaCadastro,
    setEditando,
    setTabelaRedux,
    setOpenHistoricoEdicao,
    setTelaCheck,
    setSelecionado,
    configEntrega,
}: TableBodyOrdenadoProps) {
    const {
        contextoEmbarque,
        handleSetContextoEmbarque,
    } = useProfile();

    const location = useLocation();

    const navigate = useNavigate();

    const isRotaViagens = useMemo(() => {
        return (
            location.pathname.includes("/viagens/") ||
            location.pathname.includes("/faturamento")
        );
    }, [location.pathname]);

    const isRotaViagensFinalizadasMotorista = useMemo(() => {
        return location.pathname === "/viagens-finalizadas-motorista";
    }, [location.pathname]);

    const navegarEdicaoEmbarque = useCallback((row: any) => {
        handleSetContextoEmbarque(row.contexto);
        navigate(`/viagens/${row.contexto}/cadastro/${row.idEmbarque}`);
    }, [navigate, handleSetContextoEmbarque]);

    return (
        <tbody>
            {dadosOrdenados &&
                dadosOrdenados.map((row, index) => (
                    <Fragment key={`row-${row.idEmbarque}-${index}`}>
                        <tr
                            onClick={() => {
                                setTabelaRow(row);
                            }}
                            onDoubleClick={() => {
                                if (location.pathname === "/estadia") {
                                    if (row.idEmbarque) {
                                        setIdEmbarque(row.idEmbarque);
                                        setDadosEmb(row);
                                        return;
                                    }
                                    setTelaCadastro(true);
                                    setEditando(true);
                                    setTabelaRow(row);
                                    return;
                                }

                                if (isRotaViagens && contextoEmbarque !== "todos") {
                                    navigate(
                                        `/viagens/${contextoEmbarque}/cadastro/${row.idEmbarque}`
                                    );
                                }

                                if (location.pathname === "/modelo-viagens") {
                                    navigate(
                                        `/modelo-viagens/editar/${row.idEmbarqueTemplete}`
                                    );
                                    return;
                                }

                                if (
                                    location.pathname === "/diaria-veiculos" ||
                                    isRotaViagensFinalizadasMotorista
                                ) {
                                    navegarEdicaoEmbarque(row);
                                    return;
                                }

                                if (location.pathname !== "/diaria") {
                                    if (
                                        location.pathname !== "/ontime" &&
                                        location.pathname !==
                                        "/adicionar-check-veiculo" &&
                                        location.pathname !== "/veiculos-vencidos" &&
                                        location.pathname !== "/frota"
                                    ) {
                                        setTabelaRedux({
                                            colunaSelecionada:
                                                row[classeSelecionado],
                                            usuarioAlteracao: row.usuario,
                                            dataAlteracao: row.data,
                                            row: row,
                                        });
                                        setTelaCadastro &&
                                            setTelaCadastro(true);
                                        setEditando && setEditando(true);
                                    }
                                    if (location.pathname === "/ontime") {
                                        const lista = [];
                                        lista.push(row.embarque);
                                        setTabelaRedux({
                                            colunaSelecionada:
                                                row[classeSelecionado],
                                            usuarioAlteracao: row.usuario,
                                            dataAlteracao: row.data,
                                            row: lista,
                                        });
                                        setOpenHistoricoEdicao(true);
                                    } else {
                                        setTabelaRedux({
                                            colunaSelecionada:
                                                row[classeSelecionado],
                                            usuarioAlteracao: row.usuario,
                                            dataAlteracao: row.data,
                                            row: row,
                                        });
                                        setTelaCheck?.();
                                    }
                                    setSelecionado(row[classeSelecionado]);
                                } else {
                                    navigate("/diarias", {
                                        state: { myParam: row.idGrupoCliente },
                                    });
                                }
                            }}
                            className={`hover ${striped && "striped"} 
                                                                    ${selecionado ===
                                row[
                                classeSelecionado
                                ] &&
                                "selecionado"
                                }
                                                                    ${row.cte &&
                                row.cte !==
                                null &&
                                row.cte !== "" &&
                                row.cte !== " " &&
                                row.cte !==
                                "  " &&
                                "cte"
                                }
                                                                    ${row.foiCarregado ===
                                false &&
                                "cancelado"
                                }
                                                                    ${row.foiCarregado ===
                                true && "cte"
                                }
                                                                    ${row.foiCarregado ===
                                null && "null"
                                }
                                                                    ${row.placaCavalo ===
                                null &&
                                "negrito-embarque"
                                }`}
                        >
                            {nomeTable ? (
                                <RenderBodyNomeTabela
                                    nomeTable={nomeTable}
                                    row={row}
                                    handleHover={handleHover}
                                    setLista={setLista}
                                    linhaSelecionada={linhaSelecionada}
                                    showDropDowEmbarques={showDropDowEmbarques}
                                    breakTd={breakTd}
                                    contextoEmbarque={contextoEmbarque}
                                    configEntrega={configEntrega}
                                />
                            ) : (
                                <RenderBodyColunas
                                    colunas={colunas}
                                    row={row}
                                    listaTipos={listaTipos}
                                    listaTipos2={listaTipos2}
                                    handleHover={handleHover}
                                    breakTd={breakTd}
                                    setOpenRegras={setOpenRegras}
                                    setValues={setValues}
                                    setOpenMotivo={setOpenMotivo}
                                    setTabelaRedux={setTabelaRedux}
                                    classeSelecionado={classeSelecionado}
                                    setOpen={setOpen}
                                    isEmbarque={isEmbarque}
                                    setIsEmbarque={setIsEmbarque}
                                    setIsEntrega={setIsEntrega}
                                    setDadosRastrearRedux={setDadosRastrearRedux} />
                            )}
                        </tr>
                        {linhaSelecionada.includes(row.idEmbarque) && (
                            <tr key={`detalhes-${row.idEmbarque}`}>
                                <td colSpan={8}>
                                    <TabelaV2
                                        classeSelecionado="cte"
                                        nomeClasse1="outer-wrapper-rota"
                                        nomeClasse2="table-wrapper-entregas"
                                        colunas={Entregas}
                                        dados={dadosEntrega[row.idEmbarque]}
                                    />
                                </td>
                            </tr>
                        )}
                    </Fragment>
                ))}
        </tbody>
    );
}

export default TableBodyOrdenado;